<form class="flex flex-col gap-1" [formGroup]="form">

  <app-user-dropdown [staff]="assignees()" formControlName="assigneeId"></app-user-dropdown>

  @if (showActionButtons) {
    <button class="btn btn-primary" (click)="assignIncident()">Assign</button>
  }
</form>
